export const pop = (url: string, name = 'default', options = 'directories,location,menubar,resizable,scrollbars,status,toolbar') => {
  const popupWindow = typeof window !== 'undefined' ? window.open(url, name, options) : null;
  popupWindow?.focus();
};

type PopupEvent = Event & { currentTarget: Element };

export const openPopUp = (e: PopupEvent) => {
  e.preventDefault();

  const href = e.currentTarget.getAttribute('href') as string;
  const hrefRegex = /pop\(([^)]+)\)/;
  const hrefParamsString = href.match(hrefRegex)![1];
  const paramsMatcher = /'([^']+)'/g;
  let paramMatch: RegExpExecArray | null;
  const params: string[] = [];

  do {
    paramMatch = paramsMatcher.exec(hrefParamsString);
    if (paramMatch) {
      params.push(paramMatch[1]);
    }
  } while (paramMatch);

  pop(params[0], params[1], params[2]);
};
